import React from 'react';
import InquiryDate from '../../../container/molecules/InquiryDateContainer';
import BreadcrumbsList, { BreadcrumbItem } from '../../molecules/BreadcrumbsList';
import { LoadingStatus } from '../../../redux/reducers/LoadingStatusReducer';

export interface BreadcrumbHeaderProps {
  breadcrumbsList: Array<BreadcrumbItem>;
  screenId: string;
  loadingStatus: LoadingStatus;
  isInnerHeader?: boolean;
  disableSystemError?: boolean;
  rightActions?: React.ReactNode;
}

const BreadcrumbHeader: React.FC<BreadcrumbHeaderProps> = ({
  breadcrumbsList,
  screenId,
  loadingStatus,
  isInnerHeader,
  disableSystemError,
  rightActions,
}) => {
  return (
    <div className={isInnerHeader ? 'clearfix u-mt8' : 'clearfix u-mb8'}>
      <BreadcrumbsList items={breadcrumbsList} data-testid='breadcrumbsList' />
      <div className='u-float-right'>
        {rightActions}
        <InquiryDate
          screenId={screenId}
          jobDateTime={loadingStatus.result?.jobDateTime}
          isLoading={loadingStatus.isLoading}
          error={loadingStatus.error}
          disableSystemError={disableSystemError}
          data-testid='inquiryDate'
        />
      </div>
    </div>
  );
};

export default BreadcrumbHeader;
